import Exodus from './exodus';
import Jupiter from './jupiter';
import LiFi from './li-fi';
import Rango from './rango';
const Providers = {
    Exodus,
    Jupiter,
    LiFi,
    Rango,
};
export default Providers;
